<template>
  <v-container>
    <form>
      <div>
      
      <!-- Not using this -->



        <!-- <div class="text-center d-flex pb-4"> -->
          <!-- <v-btn color="primary" @click="all">Show all</v-btn> -->
          <!-- <div>{{ panel }}</div> -->
          <!-- <v-btn color="primary" @click="none">Collapse All</v-btn> -->
          <!-- <v-btn color="primary" text disabled>Total Mark for this Question: {{ totalScore() }}</v-btn> -->
        <!-- </div> -->

        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel v-for="(item,i) in question.parts.length" :key="i">
            <v-expansion-panel-header>Part {{ item }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="10">
                  <v-textarea outlined name="input-7-4" label="Question" value="" type="number"
                    v-model="questions[i].text" disabled></v-textarea>

                  <!-- <div v-if="questions[i].type != 'SQ'">
                    <v-text-field disabled label="Choice A" placeholder="Placeholder" v-model="questions[i].optionA">
                    </v-text-field>
                    <v-text-field disabled label="Choice B" placeholder="Placeholder" v-model="questions[i].optionB">
                    </v-text-field>
                    <v-text-field disabled label="Choice C" placeholder="Placeholder" v-model="questions[i].optionC">
                    </v-text-field>
                    <v-text-field disabled label="Choice D" placeholder="Placeholder" v-model="questions[i].optionD">
                    </v-text-field>
                  </div> -->

                  <!-- <p>{{ radios || 'null' }}</p> -->
                    <v-radio-group v-if="questions[i].type != 'SQ'" v-model="questions[i].radios" :mandatory="false">
                    <v-radio :label="questions[i].optionA" value="A"></v-radio>
                    <v-radio :label="questions[i].optionB" value="B"></v-radio>
                    <v-radio :label="questions[i].optionC" value="C"></v-radio>
                    <v-radio :label="questions[i].optionD" value="D"></v-radio>
                </v-radio-group>

                  <v-textarea v-if="questions[i].type != 'MC'" outlined name="input-7-4" label="Answer" value type="number"
                    v-model="questions[i].answerText"></v-textarea>
            
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    disabled
                    label="Part Mark"
                    placeholder="0"
                    v-model="questions[i].score"
                  ></v-text-field>
                  <div style="display:none">
                    <v-select
                      :items="question_types"
                      filled
                      label="Filled style"
                      v-model="questions[i].type"
                    ></v-select>

                    <div class="my-2">
                      <v-btn color="error" v-on:click="deleteThis(i)">Delete This Part</v-btn>
                    </div>
                    <div class="my-1">
                      <v-btn v-if="i != 0" color="success" v-on:click="up(i)">⬆️</v-btn>
                      <v-btn v-if="i != items - 1" color="success" v-on:click="down(i)">⬇️</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <v-row>
        <!-- <v-col cols="4">
          <div class="text-center">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">New Part</v-btn>
              </template>

              <v-list>
                <v-list-item v-for="(item, index) in question_types" :key="index" @click="newQuestion(item.value)">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>-->

        <v-col cols="4">
          <v-btn color="success" v-on:click="sumbitForm">Save this question</v-btn>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>
export default {
  name: "AnswerQuestion",
  props: ["id"],

  data: () => ({
    panel: [],
    items: 0,
    questions: [],
    question_types: [
      { text: "Multple Choices", value: "MC" },
      { text: "[TextBox] Multiple Choices", value: "MCTB" },
      { text: "Short Question", value: "SQ" }
    ],
    answers: []
  }),

  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      this.panel = [...Array(100).keys()].map((k, i) => i);
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    deleteThis(i) {
      // console.log("here");
      // alert(JSON.stringify(this.questions));
      this.questions.splice(i, 1);
      this.items--;
    },
    newQuestion(option) {
      if (option) {
        this.questions.push({});
        this.questions[this.items].type = option;
        this.questions[this.items].score = 0;
        this.panel.push(this.items);
        this.items++;
      }
    },
    // questionTypeChanged(i) {
    //   this.questions[i].type = ""
    // },
    totalScore() {
      var totalScore = 0;

      for (var i = 0; i < this.items; i++) {
        totalScore += Number(this.questions[i].score);
      }

      return totalScore;
    },
    up(i) {
      [this.questions[i], this.questions[i - 1]] = [
        this.questions[i - 1],
        this.questions[i]
      ];
      this.all();
    },
    down(i) {
      [this.questions[i], this.questions[i + 1]] = [
        this.questions[i + 1],
        this.questions[i]
      ];
      this.all();
    },
    async sumbitForm() {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/answer/create/" + this.id,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({ questions: this.questions })
        }
      );

      if (response.ok) {
        var html = await response.text();
        alert(html);
      }
    }
  },

  async mounted() {
    var response = await fetch(
      process.env.VUE_APP_API_BASE_URL + "/question/view/" + this.id,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      }
    );

    if (response.ok) {
      var data = await response.json();
      console.log(data);

      this.questions = data.questions.slice();
      this.items = data.questions.length;
      for (var i; i < this.items; i++) {
        this.answers.push({});
      }
      this.all();
    } else {
      alert(response.status + ": " + response.statusText);
    }
  }
};
</script>